// extracted by mini-css-extract-plugin
export const responseBox = "AnalysisChartUtils-module__response-box--hONqU";